function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic_product_cat_healthaccident",
  transform: "translate(1.000000, 1.000000)",
  stroke: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.99933,0.52334 L17.1448,3.06764 C16.9873,8.24099 15.7142,11.4024 14.1764,13.4553 C12.655,15.4865 10.7671,16.5828 8.99959,17.4461 C7.23213,16.5826 5.34431,15.4862 3.82281,13.4549 C2.285,11.4019 1.01175,8.24035 0.85389,3.06679 L8.99933,0.52334 Z",
  id: "Path",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.1591,8.77966 L9.6591,8.77966 L9.6591,9.2797 L9.6591,11.099 C9.6591,11.2328 9.5506,11.3418 9.4159,11.3418 L8.55333,11.3418 C8.41876,11.3418 8.31016,11.2329 8.31016,11.099 L8.31016,9.2797 L8.31016,8.77966 L7.81016,8.77966 L5.99122,8.77966 C5.85679,8.77966 5.74805,8.67091 5.74805,8.53648 L5.74805,7.63825 C5.74805,7.50406 5.85698,7.39507 5.99122,7.39507 L7.81016,7.39507 L8.31016,7.39507 L8.31016,6.89507 L8.31016,5.07569 C8.31016,4.94151 8.4191,4.83252 8.55333,4.83252 L9.4159,4.83252 C9.5506,4.83252 9.6591,4.94107 9.6591,5.07569 L9.6591,6.89507 L9.6591,7.39507 L10.1591,7.39507 L12.0141,7.39507 C12.1483,7.39507 12.2573,7.50401 12.2573,7.63825 L12.2573,8.53648 C12.2573,8.67091 12.1486,8.77966 12.0141,8.77966 L10.1591,8.77966 Z",
  id: "Path",
  fill: "currentColor"
})));

var SvgIcProductCatHealthaccident = function SvgIcProductCatHealthaccident(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcProductCatHealthaccident, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_product_cat_healthaccident.79003a0a.svg";
export { ForwardRef as ReactComponent };